import {
  Card,
  Empty,
  Table,
} from 'antd';
import React from 'react';
import { localDateFormat } from '../../../../../utils/DateAndNumberFunctions';
import '../tableTab/TableTab.css';
import styles from './styles.module.scss';

const PlOrdReleaseTab = ({
  clientHeight, plant, material, data,
}) => {
  const getRowClassName = (record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark');

  const columns = [
    {
      children: [{
        title: 'Plant',
        dataIndex: 'plant',
        render: (v) => plant,
        width: '8%',
      }],
    },
    {
      children: [{
        title: 'Material',
        render: (v) => material,
        width: '16%',
      }],
    },
    {
      children: [{
        title: 'Released by',
        render: (v) => v.CHANGED_BY_EMAIL,
        width: '17%',
      }],
    },
    {
      children: [{
        title: 'Rel. Date Pur. Req',
        render: (v) => {
          const correctFormat = localDateFormat(v.DELIVERY_DATE);
          return correctFormat;
        },
        width: '17%',
      }],
    },
    {
      children: [{
        title: 'Quantity',
        render: (v) => v.QUANTITY,
        width: '17%',
      }],
    },
    {
      children: [{
        title: 'Requisition Number',
        render: (v) => v.REQUISITON_NUMBER,
        width: '17%',
      }],
    },
  ];

  return (
    <>
      <div style={{ height: '100%', display: 'grid', gridTemplateRows: 'auto 1fr' }}>
        <h3 style={{ color: 'var(--neutral--400)', marginLeft: '0.5rem' }}>Planned Order Changelog</h3>
        {
                  (!data || data.length === 0)
                    ? <Empty description="No data" />
                    : (

                      <Card
                        className="tabCard"
                        style={{
                          textAlign: 'center', paddingLeft: '0', paddingRight: '0', height: '100%', boxSizing: 'border-box', position: 'relative',
                        }}
                      >
                        <Table
                          className={`tabTable ${styles.plOrdReleaseTable}`}
                          rowClassName={getRowClassName}
                          columns={columns}
                          dataSource={data}
                          pagination={false}
                          size="small"
                          scroll={{ x: true, y: clientHeight }}
                          style={{ height: '100%' }}
                        />
                      </Card>

                    )
                }
      </div>
    </>
  );
};

export default PlOrdReleaseTab;
